
export const appendVersion = u => u && `${u}${u.indexOf('?') > 0 ? '&' : '?'}${process.env.REACT_APP_FRONT_VERSION}`

export default {
  appendVersion,
}
